import ErrorLayout from '@src/layout/ErrorLayout';
import { ResponseImage } from '@src/components';
import '@src/styles/components/errors.scss';
import errorImage from '@src/assets/images/error/502.svg';
import MobilErrorImage from '@src/assets/images/error/m-502.svg';

const Maintenance = () => {
  return (
    <ErrorLayout isLogo502={true}>
      <ResponseImage
        className="maintenance-img"
        mobilImage={MobilErrorImage}
        desktopImage={errorImage}
      />
    </ErrorLayout>
  );
};

export default Maintenance;
